// React
import React from "react";
import { useTranslation } from "react-i18next";

// MUI
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  DialogContentText,
} from "@mui/material";

// Styles
import { styles } from "./styles";

const ActivatePatientModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="activated-patient-dialog"
      sx={styles.dialog}
    >
      <DialogTitle sx={styles.dialogTitle}>
        {t("activatePatient.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{t("activatePatient.message")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose} sx={styles.okButton}>
          {t("buttons.ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActivatePatientModal;
